import { EvmPriceServiceConnection } from '@pythnetwork/pyth-evm-js';

export const getPythNetworkUrl = () => {
  return 'https://hermes.pyth.network';
};

export const getPythUpdateData = () => ({
  queryKey: [getPythNetworkUrl(), 'getPythUpdateData'],
  queryFn: async (ids: string[]): Promise<string[]> => {
    const connection = new EvmPriceServiceConnection(getPythNetworkUrl(), {
      timeout: 120_000, // 2min same as our wallet config
    });
    const priceUpdateData = await connection.getPriceFeedsUpdateData(ids);
    
return priceUpdateData
  },
});